import { useRef, useState } from "react";
import { Lock } from "lucide-react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const KEY = "vigilo_outbox_pw";
export const outboxPw = () => sessionStorage.getItem(KEY) || "";
export const forgetOutboxPw = () => sessionStorage.removeItem(KEY);

// -> [dialog element, ensure()] ; ensure() resolves to true once a verified password is stored
export const useOutboxPassword = () => {
  const [open, setOpen] = useState(false);
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const done = useRef(null);
  const finish = (ok) => { setOpen(false); setPw(""); setErr(""); done.current?.(ok); done.current = null; };
  const ensure = () => (outboxPw() ? Promise.resolve(true) : new Promise((res) => { done.current = res; setOpen(true); }));
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.outboxCheck(pw); sessionStorage.setItem(KEY, pw); finish(true); }
    catch (ex) { setErr(ex.message); } finally { setBusy(false); }
  };
  const dialog = (
    <Dialog open={open} onOpenChange={(o) => !o && finish(false)}>
      <DialogContent className="bg-atlas-surface border-white/10 text-white max-w-sm" data-testid="outbox-pw-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Lock className="w-4 h-4 text-amber-300" /> Outbox password</DialogTitle>
          <DialogDescription className="text-atlas-secondary">Every Outbox action (edit, approve, post, reject) needs the password set in OUTBOX_PASSWORD.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="flex flex-col gap-3">
          <input type="password" autoFocus value={pw} onChange={(e) => setPw(e.target.value)} data-testid="outbox-pw-input"
            className="h-9 bg-atlas-void border border-white/15 px-3 text-[12px] font-mono text-white focus:outline-none focus:border-atlas-cyan/60" />
          {err && <p className="text-[11px] font-mono text-atlas-red" data-testid="outbox-pw-error">{err}</p>}
          <button disabled={!pw || busy} data-testid="outbox-pw-submit"
            className="h-9 border border-emerald-400/50 text-emerald-300 text-[10px] font-mono uppercase tracking-widest hover:bg-emerald-400/10 disabled:opacity-40 transition-colors">
            {busy ? "Checking…" : "Unlock"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
  return [dialog, ensure];
};
